import { ClientType } from '../apollo'
import { types } from '../types'

import { createOneDocument } from '@dinosband/bv-main-schema/dist/client-gql'

export async function createDocument (client: ClientType, data: types.DocumentCreateInput): Promise<types.Document | undefined> {
  try {
    const result = await client.mutate({
      mutation: createOneDocument,
      variables: {
        data,
      } as types.MutationCreateOneDocumentArgs,
    })
    return result.data.createOneDocument as types.Document
  } catch (e) {
  }
}
